import { Box } from "@mui/material";
import type { FC } from "react";
import { labToCss } from "service/color-math";
import type { NamedColor } from "../filter/color-filter/ColorFilter";

export const ColorComparisonCorner: FC<{ target: NamedColor }> = ({
  target,
}) => {
  const title = `Search: ${target.name}`;
  return (
    <Box
      title={title}
      sx={{
        aspectRatio: "1 / 1",
        overflow: "hidden",
        pointerEvents: "none",
      }}
      position="absolute"
      top={0}
      right={0}
      maxHeight="30px"
      height="60%"
    >
      <Box
        width="200%"
        height="200%"
        sx={{
          pointerEvents: "initial",
          background: labToCss(target.value),
          transform: "rotate(45deg) translate(-50%, -50%)",
          "&:hover": { border: "1px dashed white" },
        }}
      />
    </Box>
  );
};
